<script lang="ts">
  // Hairline divider — the design-system divider primitive
  // (wiki/feature-design-system.md §Component primitives, AC4). A 1px rule in
  // the neutral `--line` token. The editorial layout separates sections with
  // these rather than boxing each in a card. A label sits centred between two rules.
  interface Props {
    /** Vertical margin around the rule (default `1.5rem`). */
    spacing?: string;
    label?: string | null;
    class?: string;
  }

  let { spacing = '1.5rem', label = null, class: klass = '' }: Props = $props();
</script>

{#if label}
  <div class="vd-divider vd-divider--labelled {klass}" style="--vd-divider-gap: {spacing};" role="separator" aria-label={label}>
    <span aria-hidden="true">{label}</span>
  </div>
{:else}
  <hr class="vd-divider {klass}" style="--vd-divider-gap: {spacing};" />
{/if}

<style lang="scss">
  .vd-divider {
    border: 0;
    border-top: 1px solid var(--line);
    margin: var(--vd-divider-gap) 0;
    height: 0;
  }

  .vd-divider--labelled {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    height: auto;
    border-top: 0;
    color: var(--ink-soft);
    font-family: var(--font-ui);
    font-size: var(--text-label);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.12em;
    text-align: center;
    overflow-wrap: anywhere;

    &::before,
    &::after {
      content: '';
      flex: 1 0 1.5rem;
      height: 1px;
      background: var(--ink-mute);
      opacity: 0.5;
    }

    span {
      flex: 0 1 auto;
      min-width: 0;
    }
  }
</style>
